import { render } from "./CurrentStudent.vue?vue&type=template&id=219a8a7e"
import script from "./CurrentStudent.vue?vue&type=script&lang=js"
export * from "./CurrentStudent.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__